<ng-container *ngIf="compose; else formMode">
  <div class="val-band val-band--compose">
    <ng-content></ng-content>
  </div>
</ng-container>

<ng-template #formMode>
<form class="val-band" (ngSubmit)="submit()" novalidate>
  <span class="val-band-utility" aria-hidden="true">
    <span class="val-band-utility-dot"></span>
    {{ utilityText }}
  </span>

  <div class="val-band-inputs">
    <label class="sr-only" for="sell-val-reg">Your registration</label>
    <input
      id="sell-val-reg"
      class="reg-input"
      type="text"
      name="registration"
      [(ngModel)]="registration"
      [placeholder]="regPlaceholder"
      maxlength="8"
      autocomplete="off"
      autocapitalize="characters"
      spellcheck="false"
      aria-label="Your registration" />

    <label class="sr-only" for="sell-val-reads">What buyers read this plate as</label>
    <input
      id="sell-val-reads"
      class="reads-input reads-input--inline"
      type="text"
      name="readsAs"
      [(ngModel)]="readsAs"
      [placeholder]="readsPlaceholder"
      autocomplete="off"
      aria-label="What buyers read this plate as" />
  </div>

  <button type="submit" class="btn btn--charcoal btn--full">
    {{ ctaLabel }} <span class="arrow" aria-hidden="true">&rarr;</span>
  </button>
</form>
</ng-template>
